import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsTab   from 'contents_tab';

import DraftHeader   from './draft-header';
import DraftContents from './draft-contents';
import DraftSubmit   from './draft-submit';

import ProjectPostContentsModal    from '@project/modal/post-contents-modal/_post-contents-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class Draft extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);

    window.addEventListener('beforeunload', function (event) {
      if( Object.keys(this.state.edit).length > 0 ){
        event.preventDefault();
        event.returnValue = '';
      }
    }.bind(this))
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
  console.log(this.props.data);
    this.state = {
      detail        : {},
      edit          : {},
      edit_mode     : false,
      last_draft_id : this.props.data.draft.id,
      refresh       : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * 初回データ取得
   */
  componentDidMount() {
    this.getData.bind(this)(this.props.data.draft.id);
  }
  // -------------------------------------------------------
  
  /*
   * データ取得
   */
  getData(draft_id, mode) {
    if( draft_id == null ) draft_id = this.state.last_draft_id;
    
    Utils.request.bind(this)('/api/draft/detail', { draft_id: draft_id, is_secret_mode: this.props.is_secret_mode },
      function(res){
        let detail = Object.assign(res.body.data, this.props.after_detail);
        this.setState({ detail: detail, view: true, edit: {}, edit_mode: false });
        
        if( mode == 'cancel' ){
          this.setState({ refresh: true });
          setTimeout( function(){ this.setState({ refresh: false }); }.bind(this), 50);
        }
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  updateEdit(edit) {
    this.setState({ edit: edit });
  }
  // -------------------------------------------------------
  
  toggleEditMode() {
    this.setState({ edit_mode: (this.state.edit_mode == true) ? false : true });
  }
  // -------------------------------------------------------
  
  refreshData(draft_id) {
    this.getData.bind(this)(draft_id);
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.state.detail;
    if( Object.keys(detail).length == 0 ) return null;
    
    //console.log(data);
    //console.log(detail);
    
    let edit = this.state.edit;
    
    // タブリスト
    let tabs = [];
    detail.post_contents.map((d) => {
      if( this.state.refresh == true ) return;
      tabs.push({ id: d.id, name: d.name, html: <DraftContents data={d} detail={detail} base={data} edit={edit} edit_mode={this.state.edit_mode} update_ev={this.updateEdit.bind(this)} edit_mode_ev={this.toggleEditMode.bind(this)} /> });
    });
    
    // 自身の権限を取得
    detail.is_guest = data.userData.is_guest;
    detail.my_authority = detail.authority;
    //try { detail.draft_management.accounts.map((d) => { if( d.user_id == data.userData.id ) detail.my_authority = d.authority; }); } catch(e) {}
    
    // 操作不可能状態の設定
    if( detail.my_authority == null || detail.is_submission == 0 ) detail.complete = 1;
    if( detail.is_guest_complete_mode === true ) detail.complete = 1;
    
    return (
      <div id="draft">
        <ProjectPostContentsModal data={data} project_id={data.project.id} insta_user_id={data.influencer.insta_user_id} refresh_ev={this.getData.bind(this)} />
        
        <DraftHeader data={data} detail={detail} change_ev={this.getData.bind(this)} refresh_ev={this.refreshData.bind(this)} is_secret_mode={this.props.is_secret_mode} />
        
        <div className="draft-edit-contents">
          { (data.event.showPostContents != undefined && detail.is_admin === true) && 
            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>コンテンツの編集</Tooltip>}>
              <p className="edit-post-contents" onClick={data.event.showPostContents.bind(this, data.project.id, detail.insta_user_id)}><i className="material-icons">add_circle_outline</i></p>
            </OverlayTrigger>
          }
          { (tabs.length > 0) 
            ? <ContentsTab tabs={tabs} select={tabs[0].id} font_size={16} className="sub-contents-tab" />
            : <div className="contents-none"><p>コンテンツがありません</p></div>
          }
        </div>
        <DraftSubmit data={data} detail={detail} edit={edit} edit_mode={this.state.edit_mode} update_ev={this.updateEdit.bind(this)} change_ev={this.getData.bind(this)} />
        
        { (this.state.edit_mode == true) && <div className="edit-mode-header">編集モード</div> }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Draft;